<div fxLayout="column" ngClass="p-t-xxl m-t-m p-b-l">
	<div
		fxLayout="column"
		fxLayoutAlign="flex-start center"
		fxFlex="70%"
		class="text-align-center"
	>
		<div fxLayout="row">
			<h1
				class="dark-grey-texts"
				i18n="@@homepage_organisation_orgBanner_charityMadeEasy"
			>
				Charity Fundraising Made Easy
			</h1>
		</div>
		<div fxLayout="row" fxLayoutAlign="center" ngClass="p-t-s">
			<div fxLayout="column" fxFlex.gt-sm="65%" fxFlex.sm="78%" fxFlex.xs="90%">
				<mat-card-title
					class="inc-largetext-height"
					i18n="@@homepage_organisation_orgBanner_subHeadingOne"
					>WhyDonate is the best fundraising site for charity. Raise money and
					achieve your charity goals.</mat-card-title
				>
			</div>
		</div>
		<div fxLayout="row" ngClass="p-t-xl m-t-s" fxHide.lt-sm>
			<app-start-fundraiser-button
				buttonType="homepage5"
			></app-start-fundraiser-button>
		</div>
		<div
			fxLayout="row"
			fxLayoutAlign="center"
			ngClass="p-t-xl m-t-s"
			fxHide.gt-xs
			fxFill
		>
			<div fxLayout="column" fxFlex="90%">
				<app-start-fundraiser-button buttonType="homepage6">
				</app-start-fundraiser-button>
			</div>
		</div>
		<div fxLayout="row" ngClass="p-t-xs">
			<span
				class="mat-subtitle-2 dark-grey-texts"
				i18n="@@homepage_personal_banner_zeroPercent"
			>
				0% platform fee, so let's start!
			</span>
		</div>
		<div fxLayout="row" ngClass="p-t-xl m-t-s" fxLayoutAlign="center">
			<div fxLayout="column" fxFlex.sm="70%" fxFlex.xs="90%"></div>
		</div>
	</div>
	<div
		fxLayout="column"
		fxFlex="100%"
		fxLayoutAlign="center center"
		ngClass="p-t-s"
		ngClass.xs="p-l-xl"
	>
		<div
			fxLayout.gt-sm="row"
			fxLayout.lt-md="row wrap"
			fxLayoutAlign="center center"
			fxLayoutGap.gt-md="15%"
			fxLayoutGap.md="12%"
			fxLayoutGap.sm="10%"
			fxLayoutGap.xs="11%"
		>
			<img
				ngClass.sm="p-l-xxl"
				ngClass.xs="p-t-s"
				class="hover-on-svg"
				width="65px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/salArmy/public"
			/>
			<img
				ngClass.sm="p-l-m"
				ngClass.xs="p-t-s"
				class="hover-on-svg"
				width="76px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/extinction_rebellion/public"
			/>
			<img
				ngClass.sm="p-l-m"
				ngClass.xs="p-t-s"
				class="hover-on-svg"
				width="58px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/brac/public"
			/>
			<img
				ngClass.sm="p-l-m"
				ngClass.xs="p-t-l"
				class="hover-on-svg"
				width="51px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/wwf/public"
			/>
			<img
				ngClass.sm="p-t-l p-l-m"
				ngClass.xs="p-t-l"
				class="hover-on-svg"
				width="68px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/oxfam/public"
			/>
			<img
				ngClass.sm="p-t-l p-l-m"
				ngClass.xs="p-t-l"
				class="hover-on-svg"
				width="69px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/unhcr/public"
			/>
			<img
				ngClass.sm="p-t-l"
				ngClass.xs="p-t-m"
				class="hover-on-svg"
				width="110px"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/ifrc/public"
			/>
		</div>
	</div>
</div>
